/* BYON · assets/byon-global.js · ronda 10 R1 · Base
   K1: window.byonTrack(evento, datos) → dataLayer + Shopify.analytics.publish (prefijo byon_).
   K7: Klaviyo no tapa la compra (byon-overlay-open + byon-klaviyo-open con popup y modal "Avísame").
   C1-BAS-06: al abrir "Avísame", la casilla de ofertas parte desmarcada y sin textos en inglés.
   Sin dependencias ni scripts externos. Carga con defer desde snippets/byon-head.liquid. */
(function () {
  'use strict';
  var w = window, d = document;

  /* K1 · función real (el stub inline de theme.liquid encola en byonTrackQ) */
  w.byonTrack = function (name, params) {
    try {
      var ev = String(name).indexOf('byon_') === 0 ? String(name) : 'byon_' + name;
      var pg = w.byonPage || {};
      var p = Object.assign({}, params || {}, { page_template: pg.page_template, theme_version: pg.theme_version });
      /* R2-MKT-04: GTM conserva los valores entre pushes; las claves de eventos anteriores que este no trae van en undefined */
      var K = w.__byonKeys || (w.__byonKeys = {}), reset = {};
      Object.keys(K).forEach(function (k) { if (!(k in p)) reset[k] = undefined; });
      Object.keys(p).forEach(function (k) { K[k] = 1; });
      (w.dataLayer = w.dataLayer || []).push(Object.assign({ event: ev }, reset, p));
      if (w.Shopify && w.Shopify.analytics && typeof w.Shopify.analytics.publish === 'function') w.Shopify.analytics.publish(ev, p);
      if (/[?&]byon_debug=1/.test(location.search)) console.log('[byonTrack]', ev, p);
    } catch (e) {}
  };
  var queued = w.byonTrackQ || [];
  w.byonTrackQ = [];
  queued.forEach(function (a) { w.byonTrack.apply(null, a); });

  /* K1 · un solo listener delegado: WhatsApp y promociones internas (sin preventDefault) */
  d.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      var wa = t.closest('a[href*="wa.me/"]');
      if (wa) {
        var pl = wa.closest('[data-byon-placement]');
        w.byonTrack('whatsapp_click', { placement: (pl && pl.getAttribute('data-byon-placement')) || 'other' });
      }
      var pr = t.closest('[data-byon-promo]');
      if (pr) {
        var nm = pr.getAttribute('data-byon-promo-name') || pr.textContent || '';
        w.byonTrack('select_promotion', { slot: pr.getAttribute('data-byon-promo'), promotion_name: String(nm).replace(/\s+/g, ' ').trim().slice(0, 60) });
      }
    } catch (err) {}
  }, true);

  /* K7 · overlay: se quita byon-overlay-open solo si ningún otro componente lo necesita */
  var popupOpen = false, bisOpen = false;
  function otherOverlayOpen() {
    try {
      return !!d.querySelector('cart-drawer.active, .byon-mdrawer.is-open, #ByonSearch.is-open, quick-add-modal[open], [data-byon-sort-sheet]:not([hidden]), facet-filters-form[data-byon-facets].is-open');
    } catch (e) { return false; }
  }
  function klOpen() {
    d.body.classList.add('byon-overlay-open', 'byon-klaviyo-open');
  }
  function klRelease() {
    if (popupOpen || bisOpen) return;
    d.body.classList.remove('byon-klaviyo-open');
    if (!otherOverlayOpen()) d.body.classList.remove('byon-overlay-open');
  }

  /* K7 · popup / flyout de Klaviyo ('embedOpen' = formulario embebido: no pone la clase) */
  w.addEventListener('klaviyoForms', function (e) {
    var det = e && e.detail;
    if (!det) return;
    if (det.type === 'submit') w.byonTrack('popup_submit', { form_id: det.formId, form_version_id: det.formVersionId });
    if (det.type === 'open') { popupOpen = true; klOpen(); }
    if (det.type === 'close') { popupOpen = false; klRelease(); }
  });

  /* C1-BAS-06 · Klaviyo vuelve a pintar el modal en cada apertura con la casilla marcada:
     se desmarca una vez por apertura (lo que el cliente marque después se respeta) */
  function prepBisModal(el) {
    try {
      var doc = el.contentDocument;
      if (!doc) return;
      var cb = doc.getElementById('subscribe_for_newsletter');
      if (cb) { cb.removeAttribute('checked'); cb.checked = false; }
      var lb = doc.querySelector('label[for="subscribe_for_newsletter"]');
      if (lb && /add me/i.test(lb.textContent)) lb.textContent = 'Quiero recibir ofertas y novedades de BYON';
      var cl = doc.querySelector('#completed_message .klaviyo-bis-close');
      if (cl && /^\s*close\s*$/i.test(cl.textContent)) cl.textContent = 'Cerrar';
    } catch (e) {}
  }

  /* K7 · modal "Avísame" (#klaviyo-bis-iframe): solo en fichas, donde carga onsite.js */
  function watchBisFrame(el) {
    var sync = function () {
      var visible = false;
      try { visible = el.isConnected && getComputedStyle(el).display !== 'none' && getComputedStyle(el).visibility !== 'hidden'; } catch (e) {}
      if (visible) { if (!bisOpen) prepBisModal(el); bisOpen = true; klOpen(); }
      else if (bisOpen) { bisOpen = false; klRelease(); }
    };
    new MutationObserver(sync).observe(el, { attributes: true, attributeFilter: ['style', 'class'] });
    sync();
  }
  var pt = String((w.byonPage && w.byonPage.page_template) || '');
  if (pt.indexOf('product') === 0 || d.querySelector('.klaviyo-bis-trigger')) {
    var first = d.getElementById('klaviyo-bis-iframe');
    if (first) watchBisFrame(first);
    else {
      var mo = new MutationObserver(function () {
        var el = d.getElementById('klaviyo-bis-iframe');
        if (el) { mo.disconnect(); watchBisFrame(el); }
      });
      mo.observe(d.body, { childList: true });
    }
  }
})();
